import ErrorBoundary from 'client/utils/routes/ErrorBoundary/ErrorBoundary';
import Layout from 'client/components/suc/Layout/Layout';

import { Navigate, useParams } from 'react-router';

import RequiresAuth from 'client/utils/routes/RequiresAuth/RequiresAuth';
import RequiresSignedOut from 'client/utils/routes/RequiresSignedOut/RequiresSignedOut';
import { permissions } from 'client/utils/constants/permissions';

import MapPage from 'client/pages/MapPage/MapPage';
import MapLoader from 'client/pages/MapPage/Map.loader';
import MapAction from 'client/pages/MapPage/actions/Map.action';
import MapEnquiryAction from 'client/pages/MapPage/actions/Map.enquiry.action';
import MapWorkpackAction from 'client/pages/MapPage/actions/Map.workpack.action';

import NetworkCoveragePage from 'client/pages/NetworkCoverage/NetworkCoveragePage';
import NetworkCoverageLoader from 'client/pages/NetworkCoverage/NetworkCoverage.loader';
import CreateEnquiryPage from 'client/pages/EnquiriesPage/CreateEnquiryPage/CreateEnquiryPage';
import CreateEnquiryAction from 'client/pages/EnquiriesPage/CreateEnquiryPage/CreateEnquiry.action';
import CreateEnquiryLoader from 'client/pages/EnquiriesPage/CreateEnquiryPage/CreateEnquiry.loader';
import ListEnquiryPage from 'client/pages/EnquiriesPage/ListEnquiryPage/ListEnquiryPage';
import ListEnquiryAction from 'client/pages/EnquiriesPage/ListEnquiryPage/ListEnquiry.action';
import ListEnquiryLoader from 'client/pages/EnquiriesPage/ListEnquiryPage/ListEnquiry.loader';
import ViewEnquiryPage from 'client/pages/EnquiriesPage/ViewEnquiryPage/ViewEnquiryPage';
import ViewEnquiryLoader from 'client/pages/EnquiriesPage/ViewEnquiryPage/ViewEnquiry.loader';

import CreateWorkpackPage from 'client/pages/WorkpacksPage/CreateWorkpackPage/CreateWorkpackPage';
import CreateWorkpackAction from 'client/pages/WorkpacksPage/CreateWorkpackPage/CreateWorkpack.action';
import CreateWorkpackLoader from 'client/pages/WorkpacksPage/CreateWorkpackPage/CreateWorkpack.loader';

import ListWorkpackPage from 'client/pages/WorkpacksPage/ListWorkpackPage/ListWorkpackPage';
import ListWorkpackAction from 'client/pages/WorkpacksPage/ListWorkpackPage/ListWorkpack.action';
import ListWorkpackLoader from 'client/pages/WorkpacksPage/ListWorkpackPage/ListWorkpack.loader';

import ViewWorkpackPage from 'client/pages/WorkpacksPage/ViewWorkpackPage/ViewWorkpackPage';
import ViewWorkpackLoader from 'client/pages/WorkpacksPage/ViewWorkpackPage/ViewWorkpack.loader';

import BookmarkPage from 'client/pages/BookmarkPage/BookmarkPage';
import BookmarkLoader from 'client/pages/BookmarkPage/Bookmark.loader';
import BookmarkAction from 'client/pages/BookmarkPage/Bookmark.action';

import ReaffirmationPageLoader from 'client/pages/ReaffirmationPage/Reaffirmation.loader';

import TermsAction from 'client/pages/TermsPage/Terms.action';
import TermsLoader from 'client/pages/TermsPage/Terms.loader';

import SaveObservationPage from 'client/pages/ObservationsPage/SaveObservationPage/SaveObservationPage';
import SaveObservationAction from 'client/pages/ObservationsPage/SaveObservationPage/SaveObservation.action';
import SaveObservationLoader from 'client/pages/ObservationsPage/SaveObservationPage/SaveObservation.loader';

import ListObservationPage from 'client/pages/ObservationsPage/ListObservationsPage/ListObservationPage';
import ListObservationLoader from 'client/pages/ObservationsPage/ListObservationsPage/ListObservationPage.loader';

import ViewObservationPage from 'client/pages/ObservationsPage/ViewObservationPage/ViewObservationPage';
import ViewObservationLoader from 'client/pages/ObservationsPage/ViewObservationPage/ViewObservationPage.loader';

import ListObservationAction from 'client/pages/ObservationsPage/ListObservationsPage/ListObservation.action';

import { HomePage, ReaffirmationPage, TermsPage } from 'client/pages';
import HomePageLoader from 'client/pages/HomePage/HomePage.loader';

import FeedbackPage from 'client/components/Feedback/FeedbackPage/FeedbackPage';
import FeedbackPageLoader from 'client/components/Feedback/FeedbackPage/FeedbackPage.loader';

import PlatformNoticesPage from 'client/pages/PlatformNoticesPage/PlatformNoticesPage';
import PlatformNoticesLoader from 'client/pages/PlatformNoticesPage/PlatformNoticesPage.loader';

import {
    ContactPage,
    ContactPageLoader,
    ContactPageSignedOut,
    ContactPageSignedOutLoader,
    CookiesPage,
    CookiesPageLoader,
    HelpContent,
    HelpContentLoader,
    HelpPage,
    HelpPageLoader,
    HelpPageSignedOut,
    HelpPageSignedOutLoader,
    HSG47Page,
    HSG47PageLoader,
    NewsContent,
    NewsContentLoader,
    NewsPage,
    NewsPageLoader,
    NoOrganisationsPage,
    NoOrganisationsPageLoader,
    PrivacyPage,
    PrivacyPageLoader,
    ReleaseNotes,
    ReleaseNotesLoader,
    WorkingOn,
    WorkingOnLoader
} from 'client/pages/CMSPage';

import {
    BOOKMARKS_PAGE,
    CONTACT_PAGE,
    CONTACT_PAGE_SIGNED_OUT,
    COOKIES_PAGE,
    CREATE_WORKPACK_PAGE,
    FEEDBACK_PAGE,
    HELP_PAGE,
    HELP_PAGE_CONTENT,
    HELP_PAGE_SIGNED_OUT,
    HOME_PAGE,
    HSG47_PAGE,
    MAP_PAGE,
    MAP_PAGE_ENQUIRY,
    MAP_PAGE_WORKPACK,
    WORKPACKS_PAGE,
    NETWORK_COVERAGE_PAGE,
    NEWS_PAGE,
    NEWS_PAGE_CONTENT,
    NO_ORGANISATIONS_PAGE,
    OBSERVATIONS_PAGE,
    PRIVACY_PAGE,
    REAFFIRMATION_PAGE, RELEASE_NOTES,
    SAVE_OBSERVATION_PAGE,
    SERVICE_UNAVAILABLE_PAGE,
    TERMS_AND_CONDITIONS_PAGE,
    USER_PROFILE_NOT_FOUND_PAGE,
    VIEW_WORKPACK_PAGE,
    VIEW_OBSERVATION_PAGE, WORKING_ON,
    CREATE_ENQUIRY_PAGE,
    ENQUIRIES_PAGE,
    VIEW_ENQUIRY_PAGE,
    LEGACY_VIEW_ENQUIRY_PAGE,
    LEGACY_ENQUIRIES_PAGE,
    PLATFORM_NOTICES_PAGE
} from './routeConstants';
import { USER_PROFILE_NOT_FOUND } from '../constants/errors';
import { enquiryFeatureFlag } from 'client/utils/constants/frontEndConfig';

const { MAP_VIEW, EMERGENCY_I2D_CREATE, I2D_CREATE, I2D_VIEW, OBSERVATIONS_CREATE, ENQUIRY_CREATE, ENQUIRY_VIEW } = permissions;
const viewEnquiryPathSegment = VIEW_ENQUIRY_PAGE.replace(`${ENQUIRIES_PAGE}/`, '');

export const routes = [
    {
        id: 'layout',
        path: HOME_PAGE,
        element: <Layout />,
        hydrateFallbackElement: <></>,
        errorElement: (
            <Layout>
                <ErrorBoundary />
            </Layout>
        ),
        children: [
            {
                id: 'page.home',
                index: true,
                loader: HomePageLoader,
                element: <HomePage />
            },
            {
                id: 'page.map',
                path: MAP_PAGE,
                loader: MapLoader,
                action: MapAction,
                element: (
                    <RequiresAuth requiredPermissions={[MAP_VIEW]}>
                        <MapPage />
                    </RequiresAuth>
                ),
                children: [
                    {
                        id: 'page.map.enquiry',
                        path: MAP_PAGE_ENQUIRY,
                        action: MapEnquiryAction
                    },
                    {
                        id: 'page.map.workpack',
                        path: MAP_PAGE_WORKPACK,
                        action: MapWorkpackAction
                    }
                ]
            },
            {
                id: 'page.bookmarks',
                path: BOOKMARKS_PAGE,
                loader: BookmarkLoader,
                action: BookmarkAction,
                element: (
                    <RequiresAuth requiredPermissions={[MAP_VIEW]}>
                        <BookmarkPage />
                    </RequiresAuth>
                )
            },
            {
                path: OBSERVATIONS_PAGE,
                children: [
                    {
                        id: 'page.observations.list',
                        path: OBSERVATIONS_PAGE,
                        index: true,
                        action: ListObservationAction,
                        loader: ListObservationLoader,
                        element: (
                            <RequiresAuth requiredPermissions={[MAP_VIEW, OBSERVATIONS_CREATE]}>
                                <ListObservationPage />
                            </RequiresAuth>
                        )
                    },
                    {
                        id: 'page.observations.view',
                        path: VIEW_OBSERVATION_PAGE + '/:observationId?',
                        loader: ViewObservationLoader,
                        element: (
                            <RequiresAuth requiredPermissions={[MAP_VIEW, OBSERVATIONS_CREATE]}>
                                <ViewObservationPage />
                            </RequiresAuth>
                        )
                    },
                    {
                        id: 'page.observations.save',
                        path: SAVE_OBSERVATION_PAGE + '/:observationId?',
                        action: SaveObservationAction,
                        loader: SaveObservationLoader,
                        element: (
                            <RequiresAuth requiredPermissions={[MAP_VIEW, OBSERVATIONS_CREATE]}>
                                <SaveObservationPage />
                            </RequiresAuth>
                        )
                    }
                ]
            },
            ...(
                enquiryFeatureFlag
                    ? [
                        {
                            path: ENQUIRIES_PAGE,
                            children: [
                                {
                                    id: 'page.enquiries.list.new',
                                    index: true,
                                    action: ListEnquiryAction,
                                    loader: ListEnquiryLoader,
                                    element: (
                                        <RequiresAuth requiredPermissions={[I2D_VIEW, ENQUIRY_VIEW]}>
                                            <ListEnquiryPage />
                                        </RequiresAuth>
                                    )
                                },
                                {
                                    id: 'page.enquiries.view.new',
                                    path: `${viewEnquiryPathSegment}/:enquiryId`,
                                    loader: ViewEnquiryLoader,
                                    element: (
                                        <RequiresAuth requiredPermissions={[I2D_VIEW, ENQUIRY_VIEW]}>
                                            <ViewEnquiryPage />
                                        </RequiresAuth>
                                    )
                                }
                            ]
                        },
                        {
                            id: 'page.enquiries.create.new',
                            path: CREATE_ENQUIRY_PAGE,
                            action: CreateEnquiryAction,
                            loader: CreateEnquiryLoader,
                            element: (
                                <RequiresAuth requiredPermissions={[I2D_CREATE, EMERGENCY_I2D_CREATE, ENQUIRY_CREATE]}>
                                    <CreateEnquiryPage />
                                </RequiresAuth>
                            )
                        }
                    ]
                    : []
            ),
            {
                path: LEGACY_ENQUIRIES_PAGE,
                children: [
                    {
                        id: 'page.workpacks.view_legacy',
                        path: LEGACY_VIEW_ENQUIRY_PAGE + '/:workpackReqId',
                        element: (() => {
                            const RedirectToNewUrl = () => {
                                const { workpackReqId } = useParams();
                                return <Navigate to={`${VIEW_WORKPACK_PAGE}/${workpackReqId}`}></Navigate>;
                            };
                            return <RedirectToNewUrl />;
                        })()
                    }
                ]
            },
            {
                path: WORKPACKS_PAGE,
                children: [
                    {
                        id: 'page.workpacks.list',
                        index: true,
                        action: ListWorkpackAction,
                        loader: ListWorkpackLoader,
                        element: (
                            <RequiresAuth requiredPermissions={[I2D_VIEW]}>
                                <ListWorkpackPage />
                            </RequiresAuth>
                        )
                    },
                    {
                        id: 'page.workpacks.create',
                        path: CREATE_WORKPACK_PAGE,
                        action: CreateWorkpackAction,
                        loader: CreateWorkpackLoader,
                        element: (
                            <RequiresAuth requiredPermissions={[I2D_CREATE, EMERGENCY_I2D_CREATE]}>
                                <CreateWorkpackPage />
                            </RequiresAuth>
                        )
                    },
                    {
                        id: 'page.workpacks.view',
                        path: VIEW_WORKPACK_PAGE + '/:workpackReqId',
                        loader: ViewWorkpackLoader,
                        element: (
                            <RequiresAuth requiredPermissions={[I2D_VIEW]}>
                                <ViewWorkpackPage />
                            </RequiresAuth>
                        )
                    }
                ]
            },
            {
                id: 'page.no-organisations',
                path: NO_ORGANISATIONS_PAGE,
                loader: NoOrganisationsPageLoader,
                element: (
                    <RequiresSignedOut>
                        <NoOrganisationsPage />
                    </RequiresSignedOut>
                )
            },
            {
                id: 'page.service-unavailable',
                path: SERVICE_UNAVAILABLE_PAGE,
                element: <ErrorBoundary error={{ statusCode: 503 }} />
            },
            {
                id: 'page.user-profile-not-found',
                path: USER_PROFILE_NOT_FOUND_PAGE,
                element: <ErrorBoundary error={{ statusCode: 404, message: USER_PROFILE_NOT_FOUND.message }} />
            },
            {
                id: 'page.privacy',
                path: PRIVACY_PAGE,
                loader: PrivacyPageLoader,
                element: <PrivacyPage />
            },
            {
                id: 'page.cookies',
                path: COOKIES_PAGE,
                loader: CookiesPageLoader,
                element: <CookiesPage />
            },
            {
                id: 'page.contact.signed.out',
                path: CONTACT_PAGE_SIGNED_OUT,
                loader: ContactPageSignedOutLoader,
                element: (
                    <RequiresSignedOut redirectWhenSignedIn={CONTACT_PAGE}>
                        <ContactPageSignedOut />
                    </RequiresSignedOut>
                )
            },
            {
                id: 'page.contact',
                path: CONTACT_PAGE,
                loader: ContactPageLoader,
                element: (
                    <RequiresAuth>
                        <ContactPage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.terms',
                path: TERMS_AND_CONDITIONS_PAGE,
                loader: TermsLoader,
                action: TermsAction,
                element: (
                    <RequiresAuth>
                        <TermsPage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.reaffirmation',
                path: REAFFIRMATION_PAGE + '/:reaffirmationId',
                loader: ReaffirmationPageLoader,
                element: (
                    <RequiresAuth>
                        <ReaffirmationPage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.help.signed.out',
                path: HELP_PAGE_SIGNED_OUT,
                loader: HelpPageSignedOutLoader,
                element: (
                    <RequiresSignedOut redirectWhenSignedIn={HELP_PAGE}>
                        <HelpPageSignedOut />
                    </RequiresSignedOut>
                )
            },
            {
                id: 'page.help',
                path: HELP_PAGE,
                loader: HelpPageLoader,
                element: (
                    <RequiresAuth>
                        <HelpPage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.help.content',
                path: HELP_PAGE_CONTENT,
                loader: HelpContentLoader,
                element: (
                    <RequiresAuth>
                        <HelpContent />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.hsg47',
                path: HSG47_PAGE,
                loader: HSG47PageLoader,
                element: (
                    <RequiresAuth>
                        <HSG47Page />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.news',
                path: NEWS_PAGE,
                loader: NewsPageLoader,
                element: (
                    <RequiresAuth>
                        <NewsPage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.news.releasenotes',
                path: RELEASE_NOTES,
                loader: ReleaseNotesLoader,
                element: (
                    <RequiresAuth>
                        <ReleaseNotes />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.news.workingon',
                path: WORKING_ON,
                loader: WorkingOnLoader,
                element: (
                    <RequiresAuth>
                        <WorkingOn />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.news.content',
                path: NEWS_PAGE_CONTENT,
                loader: NewsContentLoader,
                element: (
                    <RequiresAuth>
                        <NewsContent />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.network.coverage',
                path: NETWORK_COVERAGE_PAGE,
                loader: NetworkCoverageLoader,
                element: (
                    <RequiresAuth>
                        <NetworkCoveragePage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.feedback',
                path: FEEDBACK_PAGE,
                loader: FeedbackPageLoader,
                element: (
                    <RequiresAuth>
                        <FeedbackPage />
                    </RequiresAuth>
                )
            },
            {
                id: 'page.platform-notices',
                path: PLATFORM_NOTICES_PAGE,
                loader: PlatformNoticesLoader,
                element: (
                    <RequiresAuth>
                        <PlatformNoticesPage />
                    </RequiresAuth>
                )
            }
        ]
    }
];

export default routes;
